import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const creditPaymentAction = createAsyncThunk(
    'payment-credit',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/payment-credit`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const creditPaymentSlice = createSlice({
    name: 'payment-credit',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(creditPaymentAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(creditPaymentAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(creditPaymentAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const creditPaymentReducer = creditPaymentSlice.reducer    